// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"210":"f95bc7c3","215":"613cfc37","382":"7e39fd19","453":"8c0a0786","804":"a9064255","975":"19dbc444"}[chunkId] + ".chunk.js";
};